export default class Notification {
  constructor(message, severity, duration) {
    this.message = message;
    this.severity = severity || "error";
    this.duration = duration || null;
  }
}
